import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
// import { I18nProvider } from '../_metronic/i18n/i18nProvider'
// import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import { AuthProvider, useAuth } from './contexts/CustomContextHook/useAuth'
import { IsAuthorizedContextProvider } from './contexts/isAuthorizedContext'
import IdleTimerContainer from './modules/widgets/components/IdleTimerContainer'
// import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {

  toast.configure();


  
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        {/* <I18nProvider> */}
          <LayoutProvider>
            {/* <AuthInit> */}
            <AuthProvider>
            {/* <IsAuthorizedContextProvider> */}
            {/* <IdleTimerContainer/> */}
              <Routes />
              {/* </IsAuthorizedContextProvider> */}
              </AuthProvider>
            {/* </AuthInit> */}
          </LayoutProvider>
        {/* </I18nProvider> */}
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
